module.exports = __webpack_public_path__ + "static/media/voteflicks.db7eec8a.png";